//数字每三位加逗号的方法
var formatNum = function (str, type) {
  if (str == '') {
    return
  }
  if (typeof parseFloat(str) === 'number' && !isNaN(str) && str != null) {
    //判断是否是数值类型
    var newStr = "";
    var count = 0;
    if (type == 'no') {
      str = parseFloat(str)
    } else {
      str = parseFloat(str).toFixed(2)
    }
    str = str.toString();
    if (str.indexOf(".") == -1) {
      for (var i = str.length - 1; i >= 0; i--) {
        if (count % 3 == 0 && count != 0 && str.charAt(i) != '-') {
          newStr = str.charAt(i) + "," + newStr;
        } else {
          newStr = str.charAt(i) + newStr;
        }
        count++;
      }
      str = newStr; //自动补小数点后两位
    } else {
      for (var i = str.indexOf(".") - 1; i >= 0; i--) {
        if (count % 3 == 0 && count != 0 && str.charAt(i) != '-') {
          newStr = str.charAt(i) + "," + newStr;
        } else {
          newStr = str.charAt(i) + newStr; //逐个字符相接起来
        }
        count++;
      }
      str = newStr + str.substring(str.indexOf("."), str.length);
    }
  }
  if (str == '0.00' || !str) {
    str = '-'
  }
  return str
}

function date_compatible (date) {
  //new Date() 2021-09-08 20:02:00 改为 2021/09/08 20:02:00 safari ios不支持前者 返回后者
  if (date && date != '' && date != ' ') {
    return (new Date(date.replace(/-/g, "/")))
  } else {
    return new Date(date)
  }
}
module.exports = {
  formatNum: formatNum,
  date_compatible: date_compatible
}


// WEBPACK FOOTER //
// ./src/assets/js/common.js